import * as React from 'react';

import { FormattedMessage, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { updateEmail } from 'actions/account';
import { Button } from 'components/Button';
import { Form } from 'components/Form';
import { FieldText, InputText } from 'components/Input';
import { LayoutHeader } from 'components/Layout';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'constants/analytics';
import { APPLICATION_FORM_NAME } from 'constants/app';
import { sendEvent } from 'helper/analytics';
import { injectIntl } from 'helper/redux';
import { validate } from 'helper/validation/account/accountEmailUpdateForm';
import { AccountEmailUpdateForm } from 'models/account';
import { AppState } from 'models/app';

import './AccountEmailUpdate.scss';

interface StateProps {
  initialValues: AccountEmailUpdateForm;
}

interface DispatchProps {
  updateEmail: typeof updateEmail;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountEmailUpdateProps = StateProps & DispatchProps & OwnProps;

@injectIntl()
class AccountEmailUpdateContainer extends React.Component<AccountEmailUpdateProps, {}> {
  constructor(props: AccountEmailUpdateProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    const { history, initialValues, intl } = this.props;
    return (
      <Form
        className="o-container o-container--fluid o-container--fluid-vertical"
        form={APPLICATION_FORM_NAME}
        initialValues={initialValues}
        onSubmit={this.onSubmit}
        validate={validate}
      >
        <LayoutHeader actionIcon="ic-arrow-left" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title"><FormattedMessage id="account.email.update.title"/></h1>
        </LayoutHeader>

        <FieldText
          className="o-form-field"
          component={InputText}
          label={intl.formatMessage({ id: 'account.email.update.email' })}
          modifier="cancel"
          name="email"
          type="text"
        />

        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="account.email.update.continue"/>
        </Button>
      </Form>
    );
  }

  private onSubmit(formValue: AccountEmailUpdateForm) {
    sendEvent({
      action: AnalyticsEventAction.ACCOUNT_CHANGE_EMAIL,
      category: AnalyticsEventCategory.ACCOUNT_CHANGE_EMAIL
    });
    this.props.updateEmail(formValue);
  }
}

export const AccountEmailUpdate = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    initialValues: {
      email: state.accountState.account.email || ''
    }
  }), { updateEmail }
)(AccountEmailUpdateContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Email/AccountEmailUpdate/AccountEmailUpdate.tsx